/**
 * AI Marketplace — Typography tokens
 * Use these constants in MUI `sx` props and `styled()` components.
 */

export const FontFamily = {
  primary: '"Noto Sans", Arial, Helvetica, sans-serif',
} as const;
